// extracted by mini-css-extract-plugin
module.exports = {"dropDownPosition":"LessonPlaceholder_dropDownPosition_2eapr"};